import _extends from "@babel/runtime/helpers/extends";
import { Circle, WarningAmberRounded } from '@mui/icons-material';
import { Accordion, AccordionSummary, accordionSummaryClasses, Grid, Typography } from '@mui/material';
import { useMemo } from 'react';
import { ChevronDownIcon } from '../../../../assets/customIcons';
import { generateDynamicFormFields } from '../../../common/commonFunctions';
export default function FormErrorsPanel(props) {
    var _a;
    var elements = props.elements, errors = props.errors, containerProps = props.containerProps;
    var errorFields = useMemo(function () { return elements && generateDynamicFormFields(elements).filter(function (field) {
        if (!(field !== null && field !== void 0 && field.name))
            return false;
        return Boolean(errors === null || errors === void 0 ? void 0 : errors[field.name]);
    }); }, [errors, elements]);
    if (!(errorFields !== null && errorFields !== void 0 && errorFields.length))
        return null;
    return /*#__PURE__*/ React.createElement(Grid, _extends({
        item: true,
        xs: 12,
        sx: {
            py: 2,
            px: {
                xs: 2,
                sm: 3
            }
        }
    }, containerProps), /*#__PURE__*/ React.createElement(Accordion, {
        variant: "outlined",
        disableGutters: true,
        square: true,
        defaultExpanded: true,
        sx: {
            border: 1,
            borderColor: 'error.500',
            bgcolor: 'error.50',
            color: 'error.500',
            p: 1.25
        }
    }, /*#__PURE__*/ React.createElement(AccordionSummary, {
        disableRipple: true,
        expandIcon: /*#__PURE__*/ React.createElement(ChevronDownIcon, {
            fontSize: "small",
            color: "error"
        }),
        sx: (_a = {
                minHeight: 'auto',
                p: 0
            },
            _a[".".concat(accordionSummaryClasses.content)] = {
                m: 0,
                columnGap: 1
            },
            _a)
    }, /*#__PURE__*/ React.createElement(WarningAmberRounded, {
        color: "error"
    }), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: 'medium'
        }
    }, "Action pending")), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        pt: 1
    }, errorFields === null || errorFields === void 0 ? void 0 : errorFields.map(function (el) {
        if (!(el !== null && el !== void 0 && el.name))
            return null;
        var currError = errors === null || errors === void 0 ? void 0 : errors[el.name];
        var fieldLabel = '', message = '';
        if (typeof currError === 'string') {
            var _el$label;
            fieldLabel = (_el$label = el.label) !== null && _el$label !== void 0 ? _el$label : el.name;
            message = currError;
        }
        else {
            var _currError$field;
            fieldLabel = (_currError$field = currError === null || currError === void 0 ? void 0 : currError.field) !== null && _currError$field !== void 0 ? _currError$field : el.name;
            message = currError.message;
        }
        return /*#__PURE__*/ React.createElement(Grid, {
            key: el.name,
            item: true,
            container: true,
            xs: true,
            columnGap: 1.5,
            alignItems: "center",
            flexWrap: "nowrap",
            minWidth: 300
        }, /*#__PURE__*/ React.createElement(Circle, {
            color: "error",
            sx: {
                width: 6,
                height: 6
            }
        }), /*#__PURE__*/ React.createElement(Typography, {
            fontSize: "sm"
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: "sm",
            fontWeight: "medium",
            display: "inline-block"
        }, fieldLabel), " - ", message));
    }))));
}
